export const loggedEventTypes = {
    audit: "1",
};

export const operationTypes = {
    delete: "5",
    update: "3",
    read: "2",
    create: "1",
};

export const loggedEventSources = {
    default: "securesync_new",
};

// personal information const
export const getAuthChangeDescription = (personnelId, customerIds) =>
    `Updated user or authorization information for personnel Id ${personnelId} for the following customer Id's: ${customerIds}`;
export const removeAccountDescription = (personnelId, customerIds) =>
    `Removed account information for personnel Id ${personnelId}. for the following customer Id's: ${customerIds}`;
export const updatePersonnelDescription = () => `Update personnel record.`;
export const updatePersonnelComment = (personnelId, login) => `Login= ${login}; Updated Personnel ID= ${personnelId}`;
export const updateSsoPersonnelDescription = (personnelId, fName, lName, mName, bEmail) =>
    `Calling UpdateSSOUser api; Personnel Id: ${personnelId}~FirstName: ${fName}~MiddleName: ${mName}~LastName: ${lName}~BusinessEMail: ${bEmail}`;
export const updateAuthNumberDesc = () => `Reset personnel auth number.`;
export const updateAuthNumberComment = (personnelId, login) => `Login= ${login}; resetAuthNumberLogin= ${personnelId}`;

// customer auth
export const customerAuthDescAndComment = "Print Customer Authorization Report";

// dr service
export const readDrFileDesc = (fileName, customerId) =>
    `Disaster Recovery - Retrieve File: ${fileName} Customer Id: ${customerId}.`;

// request service
export const requestCancelComment = (requestId) => `Request Id= ${requestId}`;
export const requestCancelDesc = () => `Cancelled Request.`;
export const submitNewLockInsertDesc = (transportType, customerId, requestId) =>
    `Request - ${transportType === "2" ? "Deliver Empty Permanent or Temporary Transports" : "Issue Transports Permanently"} - Customer_Id=${customerId} Request_Id=${requestId}`;
export const deliveryMediaDesc = (count, customerId, requestId) =>
    `Request - Deliver Media - Submit ${count} items.  Customer_Id=${customerId} Request_Id=${requestId}`;

// reschedule service
export const rescheduleServiceDesc = () => `Rescheduled service.`;
export const rescheduleServiceComment = (from, to) => `Reschedule Service From ${from} to ${to} `;
